import { render, staticRenderFns } from "./FaqsView.vue?vue&type=template&id=8d2f31e2&"
import script from "./FaqsView.vue?vue&type=script&lang=js&"
export * from "./FaqsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports